module.exports = __webpack_public_path__ + "img/stickers-releves-mensuel-credit-renouvelable.46e1d142.jpg";